import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import AccountIcon from '../../../../../../../assets/account.svg';
import { MenuItem } from '../../../../../../ui/new-components/MenuItem';
import { HelloUserTextShimmer } from '../../../../../account/ui/shared/HelloUserText';
import { PassengersPageId } from '../../../../../app/pages/domain/constants/PageId';
import { useAuthStore } from '../../../../../auth/shared/store/useAuthStore';
import { SIGN_IN_DIALOG_HASH } from '../../../../../auth/sign-in/ui/SignInDialog';
import { useUserStore } from '../../../../../auth/user/domain/stores/useUserStore';
import { useTranslation } from '../../../../i18n/translate/useTranslation';

interface IAccountButtonProps {
	isMobileView?: boolean;
}

export const AccountButton = observer(
	({ isMobileView }: IAccountButtonProps) => {
		const { t } = useTranslation();
		const { isAuthenticated } = useAuthStore();
		const { isLoading, user } = useUserStore();
		const [authorized, setAuthorized] = useState(false);
		const [loading, setLoading] = useState(false);

		useEffect(() => {
			setAuthorized(isAuthenticated);
			setLoading(isLoading);
		}, [isAuthenticated, isLoading]);

		if (!authorized) {
			return (
				<MenuItem
					title={t('sign_in_link')}
					href={SIGN_IN_DIALOG_HASH}
					role={!isMobileView ? 'menuitem' : undefined}
					aria-label={t('sign_in_link')}
					icon={<AccountIcon />}
				/>
			);
		}

		if (loading) {
			return (
				<StyledContainer>
					<HelloUserTextShimmer />
				</StyledContainer>
			);
		}

		return (
			<StyledContainer>
				<MenuItem
					href={`/${PassengersPageId.AccountOverview}`}
					role={!isMobileView ? 'menuitem' : undefined}
					title={t('user_hello_label', { name: user?.firstName })}
					icon={<AccountIcon aria-label={t('sign_in_account_label')} />}
				/>
			</StyledContainer>
		);
	},
);

const StyledContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 4px;
	justify-content: center;
	align-items: center;
`;
